import { render, staticRenderFns } from "./Endings.vue?vue&type=template&id=32897643&"
import script from "./Endings.vue?vue&type=script&lang=js&"
export * from "./Endings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports